import {
  IBillingDetailConfiguration,
  IBillingDetailTiers,
  IBillingDetailTierSetting,
} from '~/src/dash/api/billing-detail/billing-detail-models';
import {
  parseArray,
  parseFloat,
  parseNumber,
  parseString,
  transformModel,
} from '~/src/dash/api/resource-transforms';

export const transformBillingDetailConfigurationFromAPI =
  transformModel<IBillingDetailConfiguration>({
    ID: parseNumber(['ID']),
    CreatedAt: 'CreatedAt',
    UpdatedAt: 'UpdatedAt',
    DeletedAt: 'DeletedAt',

    PublisherID: parseString(['PublisherID']),
    PublisherNameAlias: parseString(['PublisherNameAlias']),
    Product: parseString(['Product']),
    IsTiered: parseNumber(['IsTiered']),
    HasMinPrice: parseNumber(['HasMinPrice']),
    MinPrice: parseFloat(['MinPrice']),
    HasCustomCampaignPrice: parseNumber(['HasCustomCampaignPrice']),
    CustomCampaignPrice: parseFloat(['CustomCampaignPrice']),
    HasCustomVastPrice: parseNumber(['HasCustomVastPrice']),
    CustomVastPrice: parseFloat(['CustomVastPrice']),
  });

export const transformBillingDetailConfigurationToAPI = transformModel<IBillingDetailConfiguration>(
  {
    ID: parseNumber(['ID']),
    PublisherID: parseNumber(['PublisherID']),
    PublisherNameAlias: parseString(['PublisherNameAlias']),
    Product: parseString(['Product']),
    IsTiered: parseNumber(['IsTiered']),
    HasMinPrice: parseNumber(['HasMinPrice']),
    MinPrice: parseFloat(['MinPrice']),
    HasCustomCampaignPrice: parseNumber(['HasCustomCampaignPrice']),
    CustomCampaignPrice: parseFloat(['CustomCampaignPrice']),
    HasCustomVastPrice: parseNumber(['HasCustomVastPrice']),
    CustomVastPrice: parseFloat(['CustomVastPrice']),
  },
);

export const transformBillingDetailTierSettingFromAPI = transformModel<IBillingDetailTierSetting>({
  ID: parseNumber(['ID']),
  TiersID: parseNumber(['TiersID']),
  PricingTier: parseNumber(['PricingTier']),
  TiersImpressionMax: parseNumber(['TiersImpressionMax']),
  TierPrice: parseFloat(['TierPrice']),
});

export const transformBillingDetailTierSettingToAPI = transformModel<IBillingDetailTierSetting>({
  ID: parseNumber(['ID']),
  TiersID: parseNumber(['TiersID']),
  PricingTier: parseNumber(['PricingTier']),
  TiersImpressionMax: parseNumber(['TiersImpressionMax']),
  TierPrice: parseFloat(['TierPrice']),
});

export const transformBillingDetailTiersFromAPI = transformModel<IBillingDetailTiers>({
  ID: parseNumber(['ID']),
  PublisherID: parseString(['PublisherID']),
  Product: parseString(['Product']),
  BillingDetailTierSettings: parseArray(
    ['BillingDetailTierSettings'],
    transformBillingDetailTierSettingFromAPI,
  ),
});

export const transformBillingDetailTiersToAPI = transformModel<IBillingDetailTiers>({
  ID: parseNumber(['ID']),
  PublisherID: parseNumber(['PublisherID']),
  Product: parseString(['Product']),
  BillingDetailTierSettings: parseArray(
    ['BillingDetailTierSettings'],
    transformBillingDetailTierSettingToAPI,
  ),
});
